import { useEffect, useState } from 'react'
import { BaseForm, BaseSelect, BaseContenutoConProgress, BaseFeedbackConIcona, BaseButtons } from '@lucan/base-ui'
import { OPERAZIONI } from 'configuration/ConfigurazioneApi'
import { useAppContext } from 'GlobalContext'
import useNavigate from 'utils/useNavigate'
import { useSessione } from 'context/SessioneProvider'
import { CHIAVI_SESSIONE } from 'configuration/ConfigurazioneSessione'
import { useRichiestaServerLogged } from 'hook/useRichiestaServerLogged'

export default function AccessoCodiceFiscaleTest() {
  const { uri } = useAppContext()

  const {
    [CHIAVI_SESSIONE.CHIAVE_ROTTA_DOPO_ACCESSO]: chiaveRottaDopoAccesso
  } = useSessione()

  const { navigate } = useNavigate()

  const [codiciFiscali, setCodiciFiscali] = useState(null)
  const [uuidRoom, setUuidRoom] = useState(null)
  const [messaggio, setMessaggio] = useState(null)

  const {
    ScatolaMessaggi,
    inviaOperazione,
    inAttesaDelServer
  } = useRichiestaServerLogged()

  useEffect(() => {
    async function fetchCodiciFiscali() {
      const { ok, data } = await inviaOperazione(OPERAZIONI.TEST_CODICI_FISCALI, null, {}, {
        headers: { uri }
      })
      const { esito, codiciFiscali, uuidRoom, messaggio } = data
      if (ok && esito) {
        setCodiciFiscali(codiciFiscali.map(cf => ({ value: cf, label: cf })))
        setUuidRoom(uuidRoom)
      } else {
        setMessaggio(messaggio)
      }
    }
    fetchCodiciFiscali()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  async function getCookie(valoriForm) {
    const { codiceFiscale } = valoriForm
    const { ok, data } = await inviaOperazione(OPERAZIONI.TEST_COOKIE, { codiceFiscale, uuidRoom })
    if (ok && data === 'ok') navigate(chiaveRottaDopoAccesso)
  }

  return (
    <>
      {ScatolaMessaggi}

      {messaggio && <BaseFeedbackConIcona.Errore messaggio={messaggio} />}

      <BaseContenutoConProgress inAttesa={inAttesaDelServer}>
        {codiciFiscali && uuidRoom &&
          <BaseForm
            defaultValues={{ codiceFiscale: codiciFiscali[0].value }}
            onSubmit={getCookie}
          >
            <BaseSelect
              label='Codice fiscale' name='codiceFiscale'
              options={codiciFiscali}
            />
            <BaseButtons.Conferma submit size='small' sx={{ ml: 2, mt: 2 }} />
          </BaseForm>
        }
      </BaseContenutoConProgress>
    </>
  )
}